import axios from "axios";
import { Controller } from "@hotwired/stimulus";
import WaitBox from "../src/waitbox"

export default class extends Controller {
  static targets = ["paymentNoField"]
  static values = { endpoint: String, pkey: String, callbackUrl: String, accountNo: String,
    createReservationUrl: String, finalizeReservationUrl: String, amount: String
  }

  connect() {
    initEzidebitInputs()
    this.initSignupAndPayNow()
    this.termsConfirmationToggled()
  }

  initSignupAndPayNow() {
    const pkey = this.pkeyValue
    const endpoint = this.endpointValue

    eziDebit.init(pkey, {
      submitAction: "SaveCustomer",
      submitButton: "payNowButton",
      beforeSubmitCallback: () => this.prepareSubmitToEzidebit(),
      beforeEzidebitApiCall: () => this.beforeEzidebitApiCall(),
      submitCallback: (data) => this.submitSuccessCallback(data),
      submitError: (data) => this.handleSubmitError(data),
      onFormError: () => this.handleFormError(),
      customerReference: "systemReference", // In Ezidebit Online this is known as the Client Contract Ref. This is your reference for the customer
      customerLastName: "lastname",
      customerFirstName: "firstName", // If no first name is provided the customerLastName is assumed to be the Company Name
      customerAddress1: "address1",
      customerAddress2: "address2",
      customerSuburb: "suburb",
      customerState: "state",
      customerPostcode: "postcode",
      customerEmail: "email",
      customerMobile: "mobile",
      nameOnCard: "nameOnCard",
      cardNumber: "cardNumber",
      cardExpiryMonth: "expiryMonth",
      cardExpiryYear: "expiryYear",
      paymentAmount: "amount",
      paymentReference: "paymentReference"
    }, endpoint);
  }

  async prepareSubmitToEzidebit() {
    try {
      const result = await this.createReservation()
      if (result.ok) {
        const paymentNo = result.data.payment_no;
        const paymentReference = `${paymentNo}-${this.accountNoValue}`;
        $("#paymentReference").val(paymentReference);
        this.paymentNoFieldTarget.value = paymentNo;
        return true;
      } else {
        this.handleSubmitError(result.error, false)
        return false;
      }
    } catch (error) {
      this.handleSubmitError(error, false)
      return false;
    }
  }

  submitSuccessCallback(data) {
    if (data["ErrorMessage"] != null) {
      this.handleSubmitError(data["ErrorMessage"], true)
    } else {
      let paymentData = data.Data

      Object.assign(paymentData, {
        amount: $("#amount").val(),
        payment_reference: $("#paymentReference").val(),
        masked_card_number: maskString($("#cardNumber").val())
      });
      this.createPaymentAndPaymentMethod(paymentData)
    }
  }

  async handleSubmitError(error, finalizeReservation=true) {
    if (finalizeReservation) {
      const result = await this.finalizeReservation(error)
    }

    WaitBox.hide();
    bootbox.alert({
      title: formatBootboxTitle(false, "Failed"),
      className: "failure-modal",
      message: error,
      callback: function() {
        enableSubmitButton("#payNowButton", "Sign Up & Pay Now")
      }
    })
  }

  handleFormError() {
    const error = "Form data validation failed"
    this.finalizeReservation(error)
     WaitBox.hide();
     enableSubmitButton("#payNowButton", "Sign Up & Pay Now")
  }

  createPaymentAndPaymentMethod(paymentData) {
    const url = this.callbackUrlValue
    const authenticityToken = $('input[name="authenticity_token"]').val();
    axios.post(url,
      { authenticity_token: authenticityToken, transaction: paymentData },
      { headers: { 'Accept': 'text/vnd.turbo-stream.html' } }
    )
    .then(response => {
       WaitBox.hide();
      Turbo.renderStreamMessage(response.data);
    })
    .catch(error => {
       WaitBox.hide();
      showErrorMessage(error);
    });
  }

  termsConfirmationToggled(e) {
    const checkbox = document.querySelector("#ezidebit-accept-terms");
    const payNowButton = document.querySelector("#payNowButton");

    if (!checkbox) {
      return; // Exit the function if the checkbox doesn't exist
    }

    // Enable or disable the button based on the checkbox state
    payNowButton.disabled = !checkbox.checked;
  }

  beforeEzidebitApiCall() {
     WaitBox.show({ message: "Processing your payment. Please wait and do not refresh or close this page."})
  }

  async createReservation() {
    try {
      const url = this.createReservationUrlValue;
      const amount = this.amountValue;

      const resp = await axios.post(
        url,
        { authenticity_token: this.csrfToken(), payment_reservation: { amount: amount } },
        { headers: { 'X-CSRF-Token':  this.csrfToken() } }
      );

      return { ok: true, data: resp.data };
    } catch (err) {
      const msg = err?.response?.data?.error || err?.response?.data?.message || err?.message || 'Request failed';
      return { ok: false, error: msg, status: err?.response?.status };
    }
  }

  async finalizeReservation(error){
      const url = this.finalizeReservationUrlValue;
      const paymentNo = this.paymentNoFieldTarget.value;

      try {
          const resp = await axios.patch(
            url,
            {
              authenticity_token: this.csrfToken(),
              payment_reservation: {
                payment_no: paymentNo,
                status: 'failed',
                failed_reason: error
              }
            },
            { headers: { 'X-CSRF-Token': this.csrfToken() } }
          );
          return resp.data; // <— return data so caller can await/use it
        } catch (err) {
          return {error: error}
        }
    }

  csrfToken() {
    return document.querySelector('meta[name="csrf-token"]')?.content;
  }
}